import React from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import useGetMaxHeight from 'hooks/useGetMaxHeight'
import useSticky from 'hooks/useSticky'

import ListingInfo from './components/ListingInfo/ListingInfoV1'

import classes from './ProductInfoCard.module.scss'

/** @type {import("./types").default} */
const ProductInfoCard = ({
  isCypressTakingSnapshots,
  listingInfoData,
  head,
  header,
  hasRichContent,
  hideLastUpdated,
  buyerIntentMainCtaSourceLocation,
}) => {
  const [ref, isSticky] = useSticky(0)

  const height = useGetMaxHeight('[class*=ProductInfoContainer]', { extraMargin: 0 })

  return (
    <>
      <div
        data-testid="product-info-card"
        ref={ref}
        className={clsx('ProductInfoCard', classes.root, { [classes.withSticky]: !isCypressTakingSnapshots })}
        style={{
          height,
        }}
      >
        <div className={clsx('ProductInfoContainer', classes.background)}>
          <Container
            className={clsx(classes.container, {
              [classes.isSticky]: isSticky,
            })}
          >
            <div className={classes.productInfo}>
              <ListingInfo
                listingInfoData={listingInfoData}
                head={head}
                header={header}
                hasRichContent={hasRichContent}
                isCompact={isSticky}
                hideLastUpdated={hideLastUpdated}
                buyerIntentMainCtaSourceLocation={buyerIntentMainCtaSourceLocation}
              />
            </div>
          </Container>
        </div>
      </div>
      <Container>
        <div className={classes.divider} />
      </Container>
    </>
  )
}

export default ProductInfoCard
